import { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import groupService from '../../services/api/groupService';
import ReportButton from '../admin/ReportButton';
import AGTable from 'src/components/table/aggrid';
import { AdminTableSection, AdminTableContent } from 'src/assets/styles/components/AdminTable';
import { agGridDateCreatedAtFieldComparator } from '../../components/table/helpers';

const PendingGroupMembers = () => {
  const history = useHistory();
  const [loading, set_loading] = useState(true);
  const [pendingMembers, set_pendingMembers] = useState([]);
  const gridRef = useRef(null);
  const getGroupLeader = (row) =>
    row?.ChurchGroup?.maleLeader || row?.ChurchGroup?.femaleLeader || null;

  const pendingMembersColumns = [
    {
      headerName: 'Fecha inscripción',
      field: 'createdAt',
      width: 170,
      valueGetter: (params) => {
        const createdAt = params?.data?.createdAt;
        if (!createdAt) return '-';
        const date = new Date(createdAt);
        if (Number.isNaN(date.getTime())) return '-';
        return date.toLocaleDateString('es-CO');
      },
      comparator: agGridDateCreatedAtFieldComparator,
    },
    {
      headerName: 'Nombre persona',
      field: 'personName',
      width: 220,
      valueGetter: (params) => {
        const person = params?.data?.male || params?.data?.female;
        return `${person?.name || ''} ${person?.lastName || ''}`.trim() || '-';
      },
    },
    {
      headerName: 'Teléfono persona',
      field: 'personPhone',
      width: 180,
      valueGetter: (params) => {
        const person = params?.data?.male || params?.data?.female;
        return person?.phone || '-';
      },
    },
    {
      headerName: 'Identificación persona',
      field: 'personIdentification',
      width: 190,
      valueGetter: (params) => {
        const person = params?.data?.male || params?.data?.female;
        return person?.identification || '-';
      },
    },
    {
      headerName: 'Nombre grupo',
      field: 'groupName',
      width: 220,
      valueGetter: (params) => params?.data?.ChurchGroup?.groupName || '-',
    },
    {
      headerName: 'Nombre líder',
      field: 'leaderName',
      width: 220,
      valueGetter: (params) => {
        const leader =
          params?.data?.ChurchGroup?.maleLeader || params?.data?.ChurchGroup?.femaleLeader;
        return `${leader?.name || ''} ${leader?.lastName || ''}`.trim() || '-';
      },
    },
    {
      headerName: 'Teléfono líder',
      field: 'leaderPhone',
      width: 180,
      valueGetter: (params) => {
        const leader = getGroupLeader(params?.data);
        return leader?.phone || '-';
      },
    },
    {
      headerName: 'Acciones',
      field: 'actions',
      width: 170,
      sortable: false,
      filter: false,
      cellRenderer: (params) => {
        const leader = getGroupLeader(params?.data);
        if (!leader) return '-';

        const activityName = params?.data?.ChurchGroup?.activityName || '';
        const leaderUrl = `/grupos/lider?phone=${leader?.phone || ''}&identification=${
          leader?.identification || ''
        }&activityName=${activityName}`;

        return (
          <Button size="tiny" onClick={() => window.open(leaderUrl, '_blank')}>
            Ver como líder
          </Button>
        );
      },
    },
  ];

  useEffect(() => {
    if (gridRef.current) {
      gridRef?.current?.api?.sizeColumnsToFit();
    }
  }, [pendingMembers]);

  const getInfo = () => {
    groupService
      .PendingGroupPeople()
      .then((response) => {
        if (response.data.success) {
          set_pendingMembers(response?.data?.pendingMembers || []);
        }
        set_loading(false);
      })
      .catch(() => {
        set_loading(false);
      });
  };

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <AdminTableSection>
      <AdminTableContent>
        <Button onClick={() => history.push('/admin/groups/Grupo_Discipulado')}>
          Volver a grupos
        </Button>
        <h2>Personas pendientes por evaluar ingreso a un grupo</h2>
        <div style={{ margin: '16px 0' }}>
          <ReportButton
            URL={`/groups/get-groups-members-report`}
            fileName={`Personas pendientes grupos.xlsx`}
            filters={{ pendingMembers: true }}
            event="Descargar reporte"
          />
        </div>
        {loading ? (
          <p>Cargando</p>
        ) : (
          <AGTable
            rowData={pendingMembers}
            rowHeight={50}
            suppressDragLeaveHidesColumns={false}
            columnDefs={pendingMembersColumns}
            tableRef={gridRef}
          />
        )}
      </AdminTableContent>
    </AdminTableSection>
  );
};

export default PendingGroupMembers;
